import {CircleCheck, Info, OctagonAlert, TriangleAlert, XIcon} from "lucide-react";
import {ICON_SIZE} from "components/common/constants";
import React from "react";

interface NotificationProps {
    type: string;
    title?: string;
    description: string;
    dismissBtnHandler?: () => void;
    btnToolbar?: React.ReactNode;
}

export const NotificationType = {
    INFORMATION: 'information',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default'
}

const NotificationImg = ({type}) => {
    switch (type) {
        case NotificationType.INFORMATION:
            return <Info size={ICON_SIZE.MEDIUM} className="ga-notification__icon"/>;
        case NotificationType.SUCCESS:
            return <CircleCheck size={ICON_SIZE.MEDIUM} className="ga-notification__icon"/>;
        case NotificationType.WARNING:
            return <TriangleAlert size={ICON_SIZE.MEDIUM} className="ga-notification__icon"/>;
        case NotificationType.ERROR:
            return <OctagonAlert size={ICON_SIZE.MEDIUM} className="ga-notification__icon"/>;
        default:
            return null;
    }
}

export const Notification = ({type, title, description, dismissBtnHandler, btnToolbar}: NotificationProps) => {
    return (
        <div className={`ga-notification ga-notification--${type} ga-notification-widths `}>
            <NotificationImg type={type}/>
            <div className="ga-notification__content">
                {title &&
                    <div className="ga-notification__heading">
                        <div className="ga-notification__title">{title}</div>
                    </div>
                }
                {description &&
                    <p className="ga-notification__description margin-top-reset margin-bottom-unset">
                        {description}
                    </p>
                }
                {btnToolbar &&
                    <div className="mt-4 flex flex-wrap gap-2" data-testid={"__tst_btnToolbar"}>
                        {btnToolbar}
                    </div>
                }
            </div>
            {dismissBtnHandler &&
                <button
                    type="button"
                    className="ga-button ga-button--icon-only ga-button--ghost"
                    onClick={dismissBtnHandler}>
                    <XIcon size={ICON_SIZE.SMALL} data-testid={"__tst_closeIcon"}/>
                </button>
            }
        </div>

    );
}